import { connect } from 'react-redux';

import { setRoleNameError, updateRoleRequestBodyName } from '../redux/actions';

import RoleForm from './RoleForm';

const mapStateToProps = (state) => {
  return {
    role: state.rolesPermissions.role,
    drawerTitle: state.rolesPermissions.drawerTitle,
    roleNameError: state.rolesPermissions.roleNameError,
    roleRequestBody: state.rolesPermissions.roleRequestBody,
  };
};

const mapDispatchToProps = {
  setRoleNameError,
  updateRoleRequestBodyName,
};

export default connect(mapStateToProps, mapDispatchToProps)(RoleForm);
